export default {
  bookExperiencePanel: 'Paneel voor het boeken van een ervaring',
  calendarIcon: 'Kalenderpictogram',
  coverImageForResource: 'Omslagafbeelding voor {{title}} ervaringen',
  filterBy: 'Filteren op {{filter}}',
  filterByDateRange: 'Filteren op datumbereik',
  gallery: 'Galerij',
  goBack: 'Terug naar vorige pagina',
  hostUserIcon: 'pictogram van gastheer',
  imageOf: 'Afbeelding van {{title}}',
  interactiveMapAltText: 'Interactieve kaart met selecteerbare {{title}}',
  mediaSlides: "Mediadia's",
  muteVideo: 'Video dempen',
  nextPhoto: 'Volgende foto',
  noVideoPlayback: 'Geen videoweergave mogelijk',
  pauseVideo: 'Video pauzeren',
  photoOf: 'foto van {{name}}',
  playVideo: 'Video afspelen',
  previousPhoto: 'Vorige foto',
  moreFiltersAndExperiences: 'Meer filters en ervaringen',
  reserveSelectedSlot: 'Geselecteerd tijdslot reserveren',
  reviewRating: 'Beoordelingsscore {{rating}} van 5',
  overallReviewRating: 'Algemene beoordelingsscore {{rating}} van 5',
  selectCountryCodeForPhoneNumber: 'Selecteer landcode voor telefoonnummer',
  selectDate: 'Selecteer datum',
  selectParticipants: 'Selecteer deelnemers',
  selectSessionTime: 'Selecteer sessietijd',
  unmuteVideo: 'Video dempen opheffen',
  viewShoppingCart: 'Winkelwagen bekijken',
  itemsInCart: '{{count}} items in winkelwagen',
  zoomIn: 'Inzoomen',
  zoomOut: 'Uitzoomen',
  selectData: 'Selecteer {{data}}',
  reserveName: 'Reserveer {{name}}',
  deleteReservation: 'Reservering voor {{experienceTitle}} verwijderen',
  editParticipantsFor: 'Deelnemers bewerken voor {{experienceTitle}}',
  enterPromoCode: 'Voer promotiecode in',
  applyPromoCode: 'Promotiecode toepassen',
  increaseAddOnAmount: 'Geselecteerde {{addOn}} verhogen',
  decreaseAddOnAmount: 'Geselecteerde {{addOn}} verlagen',
  addOnModal: '{{addOn}} modaal venster',
  moreInformationAboutAddOn: 'Meer informatie over {{addOn}}',
  decreasePriceTierTickets: '{{priceTier}} tickets verlagen',
  increasePriceTierTickets: '{{priceTier}} tickets verhogen',
  downloadFilename: '{{filename}} downloaden',
  viewFullDetailsDescription: 'Volledige detailbeschrijving bekijken',
  viewFullDescription: 'Volledige beschrijving bekijken',
  closeModal: 'Modaal venster sluiten',
  hyattBanner: 'Exclusieve banner voor World Of Hyatt-leden',
  hyattBannerDesc:
    'Promotiebanner met exclusieve voordelen en aanbiedingen voor leden van het World of Hyatt loyaliteitsprogramma',
  previousSlide: 'Vorige dia',
  nextSlide: 'Volgende dia',
  paginationBulletMessage: 'Ga naar dia',
  exitFullscreen: 'Volledig scherm verlaten',
  enterFullscreen: 'Volledig scherm openen',
  videoSlide: 'Videodia',
  imageSlide: 'Afbeeldingsdia',
  of: 'van',
  noDescription: 'Geen beschrijving',
  mediaGallery: 'Carrousel - Mediagalerij',
  dateSelector: 'Datumkiezer',
  nextWeek: 'Volgende week',
  previousWeek: 'Vorige week',
  scheduleAgenda: 'Schema-agenda',
  scheduleNav: 'Schema-navigatie',
  scheduleViewSelector: 'Schema-weergaveselector',
  selectedDateAriaLabel: '{{date}}, geselecteerd',
  tapToBookExperience: 'Boek {{title}}',
  bookExperienceAriaLabel: 'Boek {{title}}',
  joinWaitlistAriaLabel: 'Wachtlijst voor {{title}}',
};
